import * as React from "react";

function SvgPrivacyTipBlack24Dp(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" width="1em" viewBox="0 0 22.5 22.5" {...props}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path fill="currentColor" d="M12 3.19l7 3.11V11c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1 6h2v2h-2V7zm0 4h2v6h-2v-6z" />
    </svg>
  );
}

export default SvgPrivacyTipBlack24Dp;

